import { file_upload } from '../file_upload'

export function upload_face (file: File) {
  return file_upload({
    file,
    dir: 'userface',
    type: 1,
  })
}
